export default __webpack_public_path__ + "static/media/images/r1.9b27e563.jpg";